import React from "react";
import SEO from "../../common/SEO";
import Layout from "../../common/Layout";
import AboutOne from "../../components/about/AboutOne";
import HomeFiveProgress from "../../components/home-five/HomeFiveProgress";
import CounterUpOne from "../../components/counterup/CounterUpOne";
import HeaderTwo from "../../common/header/HeaderTwo";
import { Link } from "react-router-dom";
import SectionTitle from "../../components/sectionTitle/SectionTitle";

const AboutUsThree = () => {
  return (
    <>
      <SEO
        title="About Team - GlobalDreamz"
        description="GlobalDreamz is a team of helping students and professionals achieve their dreams of studying abroad"
        keywords="Team - GlobalDreamz,globaldreamzedu"
        canonical="https://globaldreamzedu.com/about-team"
      />
      <HeaderTwo styles="header-transparent header-style-2" />
      <Layout>
        <div className="edu-event-details-area edu-event-details  bg-color-white">
          <div className="container-fluid">
            <div className="row mt-5">
              <div className="col-lg-12">
                <div className="thumbnail">
                  <img
                    className="mt--80"
                    src={`${process.env.PUBLIC_URL}/images/event/event-details/inner_team.jpg`}
                    alt="Event Thumb"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="edu-feature-area bg-color-white mt--100">
          <div className="container mediashark-animated-shape">
            <div className="row mt-5">
              <div className="col-lg-7 col-12">
                <h3>The GlobalDreamz Team </h3>
              </div>
            </div>
          </div>
        </div>

        <div className="edu-feature-area bg-color-white">
          <div className="container mediashark-animated-shape">
            <div className="row">
              <div className="col-lg-7 col-12">
                <h4>Founder</h4>
              </div>
              <div>
                <p>
                  Amar Mudbidri is the founder of GlobalDreamz. With a strong
                  background in education loans, financial services, and
                  relationship management, he built the organization with a
                  vision to make international education more accessible for
                  students and families across India.
                  <br />
                  <br />
                  His experience across banking, channel partnerships, and
                  student financing has shaped the mission of GlobalDreamz to
                  provide clear guidance, dependable support, and a student-first
                  approach for those aspiring to study abroad.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mediashark-home-five-about edu-about-area about-style-6  bg-color-white mb--100">
          <div className="container mediashark-animated-shape">
            <div className="row g-5 align-items-center">
              <div className="col-xl-4 col-lg-6">
                <div className="about-image-gallery og-hide">
                  <img
                    className="image-1 w-100"
                    src={`${process.env.PUBLIC_URL}/images/about/team/2.jpg`}
                    alt="founder"
                  />
                </div>
              </div>

              <div className="col-xl-6 col-lg-6 offset-xl-1">
                <div className="inner mt_md--40 mt_sm--20">
                  <SectionTitle title="Amar Mudbidri" />
                  <h3 className="og-font-size">Founder</h3>
                  <div className="feature-list-wrapper">
                    <p className="description line-before mt--40 mb--40">
                      Former Head - Bank Channel, Education Loans for HDFC
                      Credila. He has 20 years of experience in Channel
                      Management and Education Loans. During his career, he
                      managed National-Level Relationships with top banks like
                      HDFC Bank, SBI, ICICI Bank, Axis Bank, Citi Bank & HSBC
                      Bank etc. for various financial products while working
                      with companies like Brinks India Pvt Ltd and HDFC Credila
                      Financial SVC Ltd.
                      <br />
                      <br />
                      Amar has completed Advanced Strategic Management from IIM
                      Kozhikode.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <HomeFiveProgress />
        <AboutOne />
        <CounterUpOne />
      </Layout>
    </>
  );
};

export default AboutUsThree;
